<template>
  <div class="hide-on-print">
		<!-- Page Title -->
		<page-title
			icon="ni ni-chart-bar-32"
			main="Relatórios"
			sub="Propostas"
		>
    </page-title>

		<!-- Filter -->
		<card v-if="filters">
			<div slot="header" class="row align-items-center">
				<div class="col">
					<h5 class="h3 mb-0">Pesquisar Cliente</h5>
				</div>
			</div>
			<div class="row">
        <div class="col-4">
					<label class="form-control-label">Cliente</label>
					<multiselect
            v-model="filter.client"
            :options="clients"
						placeholder="Cliente"
						:select-label="''"
            label="name"
						:deselect-label="''"
						:selected-label="'Selecionado'"
						track-by="id"
					></multiselect>
				</div>
        <div class="col-4">
					<label class="form-control-label">Ano Safra</label>
					<multiselect
            v-model="filter.anosafra"
            :options="anosafras"
            label="descricao"
            track-by="value"
            select-label=""
            deselect-label=""
            placeholder="Safra"
            :selected-label="'Selecionado'">
          </multiselect>
				</div>
        <div class="col-md-4">
          <div style="margin-top: 1.8rem">
            <base-button icon type="purple" @click="filterProposal" style="width: 50%">
              <span class="btn-inner--text text-white">Pesquisar</span>
            </base-button>
             <base-button type="secondary" class="ml-2"  @click="exportToExcel()">Gerar Excel</base-button>
          </div>
        </div>
			</div>
		</card>
    <card>
      <proposal :loadProposals="loadProposals" :clients="clients" :proposals.sync="proposals" :approval.sync="approval"/>
    </card>
	</div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle"
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import Proposal from '../components/Proposal.vue'

export default {
  name: 'report-proposals',
  components: { 
    PageTitle, 
    Proposal,
    Multiselect
  },
  data() {
    return {
      anosafras: [],
      approval: true,
      clients: [],
      client: {},
      proposals: [],
      filters: true,
      filter: {},
      loadProposals: false
    }
  },
  mounted() {
    this.getClientsCri()
    this.getProposals()
    this.getAnosafras()
  },
  methods: {
    exportToExcel() {
      return this.$exportToExcel();
    },
    async getAnosafras () {
      const response = await this.$http.secured.get(`/api/v1/anosafras`)
      this.anosafras = response.data.anosafras
    },
    filterProposal () {
      const client_id = this.filter.client ? this.filter.client.id : null
      const anosafra_code = this.filter.anosafra ? this.filter.anosafra.id : null
      this.getProposals(client_id, anosafra_code)
    },
    async getClientsCri () {
      const response = await this.$http.secured.get("/api/v1/credit_analysis/get_clients")
      this.clients = response.data
    },
    async getProposals (client_id=null, anosafra_code=null) {
      this.loadProposals = true
      const data = {
        query: {},
        page: 1,
        per_page: 10
      }

      if (anosafra_code != null) {
        data.query.anosafra_code = anosafra_code
      }
      if (client_id != null) {
        data.query.client_id = client_id
      }

      const response = await this.$http.secured.get("/api/v1/credit_analysis/get_proposals", {params: data})
      this.proposals = response.data
      this.proposals.map(proposal => proposal.validity_date = new Date(`${proposal.validity_date}T00:00`))
      this.loadProposals = false
    },
  }
}
</script>
